import { get, put } from 'services/api';
import { FeatureFlag } from 'modules/featureFlags/types';

export const FEATURE_FLAGS_URL = '/i/admin/featureFlags';
export const IMPORT_SUBPATH = 'importIds';

/**
 * Fetches the list of feature flags.
 */
export const fetchFeatureFlags = () => get(FEATURE_FLAGS_URL);

/**
 * Fetches the changelog for a feature flag.
 */
export const fetchChangeLog = (featureFlagName: string) =>
  get(`${FEATURE_FLAGS_URL}/${featureFlagName}/changelog`);

/**
 * Saves a feature flag.
 */
export const saveFeatureFlag = (featureFlag: FeatureFlag, comment: string) => {
  const { feature, ...otherProps } = featureFlag;
  return put(`${FEATURE_FLAGS_URL}/${feature}`, { ...otherProps, comment });
};
